import axios from 'axios';
import { backendOrigin } from './backendOrigin';

const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
};

export const getPushPublicKey = async (currentUserInfo) => {
  const response = await axios.post(
    `${backendOrigin}/push/public-key`,
    {
      current_user_uid: currentUserInfo.uid,
      current_user_name: currentUserInfo.displayName,
    },
    { headers: { 'Content-Type': 'application/json' } }
  );

  if (response.data.operation !== 'success' || !response.data.info?.publicKey) {
    throw new Error(response.data.message || 'Push public key unavailable');
  }

  return response.data.info.publicKey;
};

export const subscribeToPushNotifications = async (currentUserInfo) => {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    throw new Error('Push notifications are not supported in this browser');
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Notification permission denied');
  }

  const registration = await navigator.serviceWorker.ready;
  const existing = await registration.pushManager.getSubscription();
  if (existing) {
    return existing;
  }

  const publicKey = await getPushPublicKey(currentUserInfo);
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey),
  });

  await axios.post(
    `${backendOrigin}/push/subscribe`,
    {
      subscription,
      current_user_uid: currentUserInfo.uid,
      current_user_name: currentUserInfo.displayName,
    },
    { headers: { 'Content-Type': 'application/json' } }
  );

  return subscription;
};

export const unsubscribeFromPushNotifications = async (currentUserInfo) => {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    return;
  }

  await axios.post(
    `${backendOrigin}/push/unsubscribe`,
    {
      endpoint: subscription.endpoint,
      current_user_uid: currentUserInfo.uid,
      current_user_name: currentUserInfo.displayName,
    },
    { headers: { 'Content-Type': 'application/json' } }
  );

  await subscription.unsubscribe();
};
